import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Scale, ShieldCheck, MoveLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

// Import the raw HTML string using Vite's ?raw syntax
import termsHtml from '../assets/terms.html?raw';

const TermsOfService = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-b from-[hsl(var(--gradient-start))] to-[hsl(var(--gradient-end))] pb-24 px-4 pt-[calc(env(safe-area-inset-top,0px)+1.5rem)]">
            {/* Simple public header - no app chrome */}
            <div className="max-w-2xl mx-auto mb-8 flex items-center justify-between">
                <Link to="/site" className="text-xl font-extrabold text-primary font-heading tracking-tight">HomeEzi</Link>
                <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="text-muted-foreground">
                    <MoveLeft className="mr-2 h-4 w-4" />Back
                </Button>
            </div>

            <div className="max-w-2xl mx-auto">
                {/* Header Card */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-white/60 backdrop-blur-md rounded-3xl p-8 shadow-xl border border-white/30 mb-6"
                >
                    <Button
                        variant="ghost"
                        className="mb-6 pl-0 hover:bg-transparent -ml-1"
                        onClick={() => navigate(-1)}
                    >
                        <MoveLeft className="mr-2 h-4 w-4" />
                        Back
                    </Button>

                    <div className="flex items-start gap-4 mb-6">
                        <div className="w-12 h-12 bg-primary/10 rounded-2xl flex items-center justify-center shrink-0">
                            <Scale className="w-6 h-6 text-primary" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-extrabold text-foreground tracking-tight font-heading">
                                Terms of Service
                            </h1>
                            <p className="text-sm text-muted-foreground mt-1">
                                Officially legally binding Termly Terms of Service
                            </p>
                        </div>
                    </div>

                    {/* Key badges */}
                    <div className="flex flex-wrap gap-2">
                        {["South African Law", "Liability Protected", "IP Ownership Stated"].map((badge) => (
                            <span
                                key={badge}
                                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold"
                            >
                                <ShieldCheck className="w-3 h-3" />
                                {badge}
                            </span>
                        ))}
                    </div>
                </motion.div>

                {/* Termly Official Policy Container */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="bg-white/60 backdrop-blur-md rounded-2xl p-6 shadow-sm border border-white/30 font-body overflow-hidden"
                >
                    <div 
                        className="termly-policy-container w-full break-words prose prose-sm max-w-none text-foreground/80"
                        dangerouslySetInnerHTML={{ __html: termsHtml }} 
                    />
                </motion.div>

                {/* Footer note */}
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8 }}
                    className="text-center text-xs text-muted-foreground mt-8"
                >
                    These Terms of Service are governed by the laws of the Republic of South Africa.
                    By using HomeEzi, you agree to these Terms in full.
                </motion.p>
            </div>
        </div>
    );
};

export default TermsOfService;
